import { TranslocoModule } from '@jsverse/transloco';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LuggageTooltipComponent } from '@shared/luggage/luggage-tooltip/luggage-tooltip.component';
import { LuggagePipe } from '@shared/luggage/pipes/luggage.pipe';
import { LuggageService } from '@shared/luggage/services/luggage.service';
import { TypeLuggagePipe } from '@shared/luggage/pipes/type-luggage.pipe';
import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import { BackgroundSurfaceDsComponent } from '@design-system/components/atoms/background-surface/background-surface.component';
import { DividerDsComponent } from '@design-system/components/atoms/divider/divider.component';

@NgModule({
  declarations: [
    LuggageTooltipComponent,
    LuggagePipe,
    TypeLuggagePipe
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    GlobalPipesModule,
    IconDsComponent,
    TypographyDsComponent,
    BackgroundSurfaceDsComponent,
    DividerDsComponent,
  ],
  exports: [
    LuggageTooltipComponent,
    LuggagePipe,
    TypeLuggagePipe,
  ],
  providers: [LuggageService, LuggagePipe]
})
export class LuggageModule { }
